import '.a0{height:40vh;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.a1{flex-direction:row;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { pages } from '@app/util/links'
import { styled } from 'inlines'
import React, { Component, ErrorInfo, ReactNode } from 'react'
import { PageLayout } from '../layout/PageLayout'
import { Button } from '@app/components/core/button/Button'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
    }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  override render() {
    if (this.state.hasError) {
      const isDev =
        process.env.NODE_ENV === 'development' ||
        (typeof window !== 'undefined' &&
          (window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1'))

      if (!isDev) {
        return (
          <PageLayout>
            <div className="a0 a a1 c"
            >
              <Column
                style={{
                  gap: '0.5rem',
                  alignItems: 'center',
                }}
              >
                <Title.H3>Something went wrong</Title.H3>
                <Row>
                  <Button
                    label="Reload"
                    onClick={() => window.location.reload()}
                  />
                  <Button
                    label="Home"
                    variant="secondary"
                    onClick={() => (window.location.href = pages.home)}
                  />
                </Row>
              </Column>
            </div>
          </PageLayout>
        )
      }

      return (
        <div
          style={{
            padding: '2rem',
            margin: '1rem',
            border: '1px solid #f87171',
            backgroundColor: '#fef2f2',
            borderRadius: '0.5rem',
            color: '#991b1b',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <h2 style={{ marginTop: 0, fontSize: '1.25rem' }}>
            Something went wrong.
          </h2>

          {this.state.error && (
            <details style={{ marginTop: '1rem', whiteSpace: 'pre-wrap' }} open>
              <summary>Error Details (Localhost Only)</summary>
              <pre
                style={{
                  backgroundColor: '#fff',
                  padding: '1rem',
                  borderRadius: '0.25rem',
                  overflowX: 'auto',
                  fontSize: '0.85rem',
                  color: '#333',
                  border: '1px solid #ddd',
                  marginTop: '0.5rem',
                }}
              >
                {this.state.error.toString()}
                <br />
                {this.state.error.stack}
              </pre>
            </details>
          )}
        </div>
      )
    }

    return this.props.children
  }
}
